import { createGlobalStyle } from 'styled-components';

const AppStyle = createGlobalStyle<{ isValueEmbed: boolean }>`
  html,
  html body,
  #app {
    ${(props) =>
      props.isValueEmbed
        ? `display: inline-block;
        width: max-content;
        max-width: 760px;`
        : `display: flex;
        flex-direction: column;
        flex-grow: 1;
        margin: 0 !important;
        z-index: 0;
        overflow-x: hidden;

        position: relative; /* Needed for createScrollPositionHandler() */

        /* @atlaskit/css-reset sets height: 100% on html,body. This breaks the flex box height. */
        height: auto;
        min-height: 100%;`}
  }

  html.is-dragging .draggable-li .dragging-active {
    opacity: 1;
  }

  html.is-dragging .draggable-li:hover .dragging-inactive {
    opacity: 0;
  }

  html.is-dragging .draggable-li:not(.active-view) {
    background: none;
  }

  html.is-dragging .draggable-li:hover .view-card-button,
  html.is-dragging .draggable-li:hover .view-actions-menu-trigger-button {
    visibility: hidden;
    width: 0px;
  }

  html.is-dragging .draggable-li:hover .view-card-default-text {
    margin-right: -10px;
  }
`;

export default AppStyle;
